import { createApp } from 'vue'

// jQuery/DataTables globals must be set before the plugin side-effect imports below.
import './libs/globals'

import './assets/font-awesome/css/fontawesome-all.css'

import 'bootstrap/less/bootstrap.less'
import 'bulma/bulma.sass'

import 'components-jqueryui/jquery-ui.min.js'
import 'components-jqueryui/themes/ui-lightness/jquery-ui.min.css'

import 'bootstrap/js/dropdown.js'

import './assets/js/colReorder.js'
import './assets/js/input.js'

/** Datatable buttons */
import 'datatables.net-buttons/js/dataTables.buttons.min.js'
import 'datatables.net-buttons/js/buttons.flash.min.js'
import 'datatables.net-buttons/js/buttons.html5.min.js'
import 'datatables.net-buttons/js/buttons.print.min.js'
import 'datatables.net-select/js/dataTables.select.min.js'

import './assets/css/jquery.dataTables_themeroller.css'
import './assets/css/jquery.dataTables.css'

import 'binary-com-jquery-ui-timepicker/jquery.ui.timepicker.css'
import 'binary-com-jquery-ui-timepicker/jquery.ui.timepicker.js'

import './libs/jSignature.min.noconflict.js'

// pdfmake for datatables' buttons.html5 export (replaces the CDN scripts that
// used to live in index.html)
import pdfMake from 'pdfmake/build/pdfmake'
import vfsFontsSource from 'pdfmake/build/vfs_fonts.js?raw'
// vfs_fonts.js is a bare script (`this.pdfMake.vfs = {...}`) with no module
// exports, and in an ESM module `this` is undefined — so evaluate it against
// a fresh host object instead of importing it as a module.
const vfsHost = {}
;(new Function(vfsFontsSource)).call(vfsHost)
pdfMake.vfs = vfsHost.pdfMake.vfs
window.pdfMake = pdfMake

import App from './common/App'
import router from './router'
import store from './store'

//*.vue files
import Header from './components/Home/Header'
import Nav from './components/Home/Nav'
import UserProfile from './components/Home/UserProfile'
import HomeTitle from './components/Home/HomeTitle'

import SessionExpired from './components/Home/Modals/SessionExpired'
import CancelRequestConfirm from './components/Home/Modals/CancelRequestConfirm'
import CancelRequestNotSaved from './components/Home/Modals/CancelRequestNotSaved'
import CancelRequestSuccess from './components/Home/Modals/CancelRequestSuccess'
import RequestCancelled from './components/Home/Modals/RequestCancelled'
import LastMinuteCancel from './components/Home/Modals/LastMinuteCancel'
import RequiredField from './components/Home/Modals/RequiredField'
import Profile from './components/Home/Modals/Profile'
import ProfileImageUploadMessage from './components/Home/Modals/ProfileImageUploadMessage'
import AccountNotSaved from './components/Home/Modals/AccountNotSaved'
import AccountSaved from './components/Home/Modals/AccountSaved'
import ProfileNotSaved from './components/Home/Modals/ProfileNotSaved'
import DeleteCompletedVOSConfirm from './components/Home/Modals/DeleteCompletedVOSConfirm'
import DeleteCompletedVOSSuccess from './components/Home/Modals/DeleteCompletedVOSSuccess'
import UploadCompletedVOSSuccess from './components/Home/Modals/UploadCompletedVOSSuccess'

import DeleteUploadedVOSConfirm from './components/Home/Modals/DeleteUploadedVOSConfirm'
import DeleteUploadedVOSSuccess from './components/Home/Modals/DeleteUploadedVOSSuccess'
import VosViewUploaded from './components/Home/Modals/VosViewUploaded'
import VosViewDigital from './components/Home/Modals/VosViewDigital'
import ViewUploadedFiles from './components/Home/Modals/ViewUploadedFiles'

import Requests from './components/Home/Requests'
import IntepretationDetails from './components/Home/Views/IntepretationDetails'
import TranslationDetails from './components/Home/Views/TranslationDetails'
import TelephonicDetails from './components/Home/Views/TelephonicDetails'

import RequestTabs from './components/Home/RequestTabs'
import RequestInfoButtons from './components/Home/RequestInfoButtons'
import RequestFiles from './components/Home/Views/RequestFiles'
import RequestVos from './components/Home/Views/RequestVos'

import RequestsTable from './components/Home/Tables/RequestsTable'

import ViewRequestsForm from './components/Home/Forms/ViewRequestsForm'
import ProfileForm from './components/Home/Forms/ProfileForm'

import AutocompleteText from '@/reusable_components/AutocompleteText'
import jQueryUIDatePicker from '@/reusable_components/jQueryUIDatePicker'
import CustomDataTables from '@/reusable_components/DataTables'

import NotificationModal from '@/reusable_components/NotificationModal'
import ClipLoader from '@/reusable_components/ClipLoader'
import FileUploader from '@/reusable_components/FileUploader'
import AppIcon from '@/reusable_components/AppIcon'

import VueTimepicker from 'vue3-timepicker'
import 'vue3-timepicker/dist/VueTimepicker.css'

const app = createApp(App).use(router).use(store)

app.component('icon', AppIcon)

/**/
app.component('header-component', Header)
app.component('nav-component', Nav)
app.component('user-component', UserProfile)
app.component('title-component', HomeTitle)

app.component('session-expired-modal', SessionExpired)
app.component('cancel-request-confirm-modal', CancelRequestConfirm)
app.component('cancel-request-not-saved-modal', CancelRequestNotSaved)
app.component('cancel-request-success-modal', CancelRequestSuccess)
app.component('request-cancelled-modal', RequestCancelled)
app.component('last-minute-cancel-modal', LastMinuteCancel)
app.component('required-field-modal', RequiredField)
app.component('profile-modal', Profile)
app.component('profile-upload-message-modal', ProfileImageUploadMessage)
app.component('account-not-saved-modal', AccountNotSaved)
app.component('account-saved-modal', AccountSaved)
app.component('profile-not-saved-modal', ProfileNotSaved)
app.component('delete-completed-vos-confirm-modal', DeleteCompletedVOSConfirm)
app.component('delete-completed-vos-success-modal', DeleteCompletedVOSSuccess)
app.component('upload-completed-vos-success-modal', UploadCompletedVOSSuccess)

app.component('delete-uploaded-vos-confirm-modal', DeleteUploadedVOSConfirm)
app.component('delete-uploaded-vos-success-modal', DeleteUploadedVOSSuccess)
app.component('vos-uploaded-modal', VosViewUploaded)
app.component('vos-digital-modal', VosViewDigital)
app.component('view-uploaded-files-modal', ViewUploadedFiles)


app.component('requests', Requests)

app.component('interpretation-details', IntepretationDetails)
app.component('translation-details', TranslationDetails)
app.component('telephonic-details', TelephonicDetails)

app.component('request-tabs', RequestTabs)
app.component('request-info-buttons', RequestInfoButtons)
app.component('request-files', RequestFiles)
app.component('request-vos', RequestVos)

app.component('view-requests', ViewRequestsForm)
app.component('profile', ProfileForm)

app.component('autocomplete-text', AutocompleteText)
app.component('jqueryui-datepicker', jQueryUIDatePicker)

app.component('server-tables', CustomDataTables)

app.component('vendor-tables', RequestsTable)

app.component('notification-modal', NotificationModal)
app.component('cliploader', ClipLoader)

app.component('file-uploader', FileUploader)
app.component('vue-timepicker', VueTimepicker)

app.mount('#app')